var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"register",attrs:{"dark":"","loading":_vm.loading,"color":"white green--text"},on:{"click":_vm.trigger}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }